export default __webpack_public_path__ + "static/media/thirdBg.45cac2e1.png";